import { FormFieldValue } from "@/domains/datablocks/types";

const FIELD_VALUE_ATTR_PATTERN = /^fieldValues\.(\d+)(\..+)?$/;

/**
 * The API reports field errors by position in the payload it received
 * (`fieldValues.<index>.value`). The form names its inputs by position in the
 * template's full `fieldValues` array, which still holds the disabled fields
 * that are stripped out just before the request. Without this translation every
 * error after a stripped field lands on the wrong input.
 */
export const createFieldValueAttrMapper =
  (submittedFieldValues: FormFieldValue[], formFieldValues: FormFieldValue[]) =>
  (attr: string): string => {
    const match = FIELD_VALUE_ATTR_PATTERN.exec(attr);
    if (!match) return attr;

    const submitted = submittedFieldValues[Number(match[1])];
    if (!submitted) return attr;

    const formIndex = formFieldValues.findIndex(
      (fieldValue) => fieldValue.field === submitted.field,
    );
    if (formIndex === -1) return attr;

    return `fieldValues.${formIndex}${match[2] ?? ""}`;
  };
